var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8001 5.46666H6.80013C6.06375 5.46666 5.4668 6.06361 5.4668 6.79999V12.8C5.4668 13.5364 6.06375 14.1333 6.80013 14.1333H12.8001C13.5365 14.1333 14.1335 13.5364 14.1335 12.8V6.79999C14.1335 6.06361 13.5365 5.46666 12.8001 5.46666Z",
    stroke: "#ABABAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79043 10.6761C2.54038 10.4261 2.3999 10.0869 2.3999 9.73333V3.73333C2.3999 3.37971 2.54038 3.04057 2.79043 2.79052C3.04048 2.54047 3.37961 2.39999 3.73324 2.39999H9.73324C10.0869 2.39999 10.426 2.54047 10.676 2.79052",
    stroke: "#ABABAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.47ec6af260a87290b6eba4784f10c6fa.svg";
export { ForwardRef as ReactComponent };